import { MapWorkOrder } from '@atom/types/map';

import NoItemsPane from './NoItemsPane';
import WorkOrdersListItem from './WorkOrdersListItem';

import classes from './drawerContent.module.css';

interface Props {
  workOrders: MapWorkOrder[];
  navigateToWorkOrder: (id: string) => void;
}

const WorkOrderList = ({ workOrders, navigateToWorkOrder }: Props) => {
  const totalVisible = workOrders.length;

  return (
    <div className={classes.sidepaneListContainer}>
      <div className={classes.listHeader}>{`${totalVisible} work`}</div>
      {!totalVisible ? (
        <NoItemsPane
          icon="work_off"
          text={[
            'There is no work in this map area.',
            'Please zoom out or move around on map to find work.',
          ]}
        />
      ) : (
        <div className={classes.listItemContainer}>
          {workOrders.map(workOrder => (
            <WorkOrdersListItem
              key={workOrder.id}
              workOrder={workOrder}
              navigateToWorkOrder={navigateToWorkOrder}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default WorkOrderList;
